import { useState, useEffect } from 'react';
import { getAccessToken } from '../utils/auth';

function Agents({ onEditAgent }) {
  const [agents, setAgents] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'modified', direction: 'desc' });
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showMenu, setShowMenu] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [agentToDelete, setAgentToDelete] = useState(null);
  const [searchFilter, setSearchFilter] = useState('');

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${(date.getMonth()+1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });
  };

  const filteredAgents = agents.filter(agent => {
    if (searchFilter.length < 3) return true;
    return agent.display_name?.toLowerCase().includes(searchFilter.toLowerCase());
  });

  const sortedAgents = [...filteredAgents].sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    let aValue, bValue;
    if (sortConfig.key === 'settings.ds_type') {
      aValue = (a.settings?.ds_type || 'unset').toLowerCase();
      bValue = (b.settings?.ds_type || 'unset').toLowerCase();
    } else if (sortConfig.key === 'settings.llm_provider') {
      aValue = (a.settings?.llm_provider || 'unset').toLowerCase();
      bValue = (b.settings?.llm_provider || 'unset').toLowerCase();
    } else {
      aValue = a[sortConfig.key]?.toString().toLowerCase() || '';
      bValue = b[sortConfig.key]?.toString().toLowerCase() || '';
    }
    
    return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
  });

  useEffect(() => {
    const fetchAgents = async () => {
      const token = await getAccessToken();
      if (token) {
        fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/knowledgebase`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
          .then(response => response.json())
          .then(data => setAgents(data))
          .catch(error => console.error('Error fetching agents:', error));
      }
    };
    fetchAgents();
  }, []);



  return (
    <div>
      <div className="header-layout">
        <h2 className="header-title">Agents</h2>
        <button className="btn-add" onClick={() => onEditAgent && onEditAgent('00000000000000000000000000000000')}>
          Add Agent
        </button>
      </div>
      <input
        type="text"
        className="form-input"
        placeholder="Search agent..."
        value={searchFilter}
        onChange={(e) => setSearchFilter(e.target.value)}
        style={{ marginBottom: '20px', width: '300px' }}
      />

      {/* <div className="scrollable-table-wrapper agents-table"> */}
      {/* <div className="scrollable-table-wrapper"> */}
      {/* <div className="agents-table"> */}
        <table className="data-table agents-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('settings.ds_type')} style={{ cursor: 'pointer' }}>Source</th>
              <th onClick={() => handleSort('display_name')} style={{ cursor: 'pointer' }}>Name</th>
              <th onClick={() => handleSort('description')} style={{ cursor: 'pointer' }}>Description</th>
              <th onClick={() => handleSort('settings.llm_provider')} style={{ cursor: 'pointer' }}>Transform with LLM</th>
              <th onClick={() => handleSort('created')} style={{ cursor: 'pointer' }}>Created</th>
              <th onClick={() => handleSort('modified')} style={{ cursor: 'pointer' }}>Modified</th>
              <th style={{ width: '50px' }}></th>
            </tr>
          </thead>
          <tbody>
            {sortedAgents.map((agent, index) => (
              <tr key={index} onMouseEnter={() => setHoveredRow(index)} onMouseLeave={() => setHoveredRow(null)}>
                <td data-column="source"><img src={`/media/${(agent.settings?.ds_type || 'unset').toLowerCase()}-icon.png`} alt={agent.settings?.ds_type || 'unset'} style={{ width: '24px', height: '24px' }} /></td>
                <td data-column="display_name" onClick={() => onEditAgent && onEditAgent(agent.id)} style={{ cursor: 'pointer' }}>{agent.display_name}</td>
                <td data-column="description" title={agent.description}>{agent.description}</td>
                <td data-column="llm_provider"><img src={`/media/${(agent.settings?.llm_provider || 'unset').toLowerCase()}-icon.png`} alt={agent.settings?.llm_provider || 'unset'} style={{ width: '24px', height: '24px' }} /></td>
                <td data-column="created" onClick={() => onEditAgent && onEditAgent(agent.id)} style={{ cursor: 'pointer' }}>{formatDate(agent.created)}</td>
                <td data-column="modified" onClick={() => onEditAgent && onEditAgent(agent.id)} style={{ cursor: 'pointer' }}>{formatDate(agent.modified)}</td>
                <td data-column="actions" className="agents-actions-cell">
                  {hoveredRow === index && (
                    <span 
                      onMouseEnter={() => setShowMenu(index)}
                      className="agents-ellipsis"
                    >
                      ⋯
                    </span>
                  )}
                  {showMenu === index && (
                    <div 
                      onMouseEnter={() => setShowMenu(index)}
                      onMouseLeave={() => setShowMenu(null)}
                      className="agents-menu"
                    >
                      <div onClick={() => { onEditAgent && onEditAgent(agent.id); setShowMenu(null); }} className="agents-menu-item">Edit</div>
                      <div onClick={() => { setAgentToDelete(agent); setShowDeleteModal(true); setShowMenu(null); }} className="agents-menu-item">Delete</div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      {/* </div> */}

      {showDeleteModal && agentToDelete && (
        <div className="modal-overlay">
          <div className="modal-content modal-content-compact">
            <h3>Delete Agent</h3>
            <p>All associated configurations and data will be deleted.</p>
            <p>Are you sure you want to delete the agent "{agentToDelete.display_name}"?</p>
            <div className="modal-buttons">
              <button className="btn-cancel" onClick={() => { setShowDeleteModal(false); setAgentToDelete(null); }}>Cancel</button>
              <button className="btn-save" onClick={async () => {
                const token = await getAccessToken();
                if (token) {
                  try {
                    await fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/knowledgebase/${agentToDelete.id}`, {
                      method: 'DELETE',
                      headers: { 'Authorization': `Bearer ${token}` }
                    });
                    setAgents(agents.filter(a => a.id !== agentToDelete.id));
                  } catch (error) {
                    console.error('Error deleting agent:', error);
                  }
                }
                setShowDeleteModal(false);
                setAgentToDelete(null);
              }}>Yes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Agents;